import { getLocalApi } from "./localApi";
import { Fee } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";
import { readHasActiveOffering, readIsUsedInActivePackage } from "./productDtoHelpers";

import { DivisionId } from "app/shared/division/getDivisionId";

const mapDtoToFee = (dto: any): Fee => ({
  id: dto.id,
  name: dto.name,
  unitTypeId: dto.unitTypeId,
  unitTypeName: dto.unitTypeName,
  active: dto.active,
  lastModifiedDate: dto.lastModifiedDate ?? null,
  lastUpdatedBy: dto.lastUpdatedBy ?? dto.lastModifiedBy ?? "",
  entityUpdate: dto.entityUpdate,
  excludedBookingSystemIds: [],
  hasActiveOffering: readHasActiveOffering(dto),
  isUsedInActivePackage: readIsUsedInActivePackage(dto),
});

export async function getAllFees(): Promise<Fee[]> {
  const divisionId = DivisionId();
  return getAllFeesForDivision(divisionId);
}

export async function getAllFeesForDivision(divisionId: number): Promise<Fee[]> {
  const localApi = await getLocalApi();
  return await localApi.fetchList(
    apiConfig.fees_get_fees.replace("{divisionId}", divisionId.toString()),
    mapDtoToFee,
    "Unable to fetch fees"
  );
}
